import React from 'react';
import * as keyMenu from '../scripts/KeyMenu';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileInvoice, faClock, faCalendarAlt, faFileInvoiceDollar, faStopwatch, faUserClock, faAddressCard, faCalendarCheck, faSquarePollVertical, faScaleBalanced, faHammer, faHandHoldingDollar } from "@fortawesome/pro-duotone-svg-icons";
import * as storage from '../utils/storage';
import stylesNav from '../styles/menuNavigation.module.css';

export function getMenuConfig(key) {
    switch (key) {
        case keyMenu.MENU_PUNCH:
            return {
                color: 'rgb(106 142 245)',
                icon: <FontAwesomeIcon icon={faStopwatch} style={{ color: 'rgb(106 142 245)' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faStopwatch} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_PUNCH,
                descriptionF: '',
                descriptionE: '',
                descriptionAbbrF: '',
                descriptionAbbrE: '',
                getThisDesc: false,
                priority: 1
            };
        case keyMenu.MENU_DOCUMENTS:
            return {
                color: 'rgb(245 117 6)',
                icon: <FontAwesomeIcon icon={faFileInvoice} style={{ color: 'rgb(245 117 6)' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faFileInvoice} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_DOCUMENTS,
                descriptionF: '',
                descriptionE: '',
                descriptionAbbrF: '',
                descriptionAbbrE: '',
                getThisDesc: false,
                priority: 0
            };
        case keyMenu.MENU_REQUEST:
            return {
                color: '#ffca00',
                icon: <FontAwesomeIcon icon={faUserClock} style={{ color: '#ffca00' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faUserClock} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_REQUEST,
                descriptionF: '',
                descriptionE: '',
                descriptionAbbrF: '',
                descriptionAbbrE: '',
                getThisDesc: false,
                priority: 20
            };
        case keyMenu.MENU_TIMESHEET:
            return {
                color: '#ff8888',
                icon: <FontAwesomeIcon icon={faClock} style={{ color: '#ff8888' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faClock} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_TIMESHEET,
                descriptionF: '',
                descriptionE: '',
                descriptionAbbrF: '',
                descriptionAbbrE: '',
                getThisDesc: false,
                priority: 30
            };
        case keyMenu.MENU_SCHEDULE:
            return {
                color: '#ba4ccdc7',
                icon: <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#ba4ccdc7' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faCalendarAlt} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_SCHEDULE,
                descriptionF: '',
                descriptionE: '',
                descriptionAbbrF: '',
                descriptionAbbrE: '',
                getThisDesc: false,
                priority: 40
            };
        case keyMenu.MENU_EXPENSES:
            return {
                color: '#4db951',
                icon: <FontAwesomeIcon icon={faFileInvoiceDollar} style={{ color: '#4db951' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faFileInvoiceDollar} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_EXPENSES,
                descriptionF: '',
                descriptionE: '',
                descriptionAbbrF: '',
                descriptionAbbrE: '',
                getThisDesc: false,
                priority: 50
            };
        case keyMenu.MENU_PROFILE:
            return {
                color: '#008cad',
                icon: <FontAwesomeIcon icon={faAddressCard} style={{ color: '#008cad' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faAddressCard} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_PROFILE,
                descriptionF: 'MonDossier',
                descriptionE: 'MyFile',
                descriptionAbbrF: '',
                descriptionAbbrE: '',
                getThisDesc: true,
                priority: 60
            };
        case keyMenu.MENU_SCHEDULEAVAILABILITY:
            return {
                color: '#e53a9fc7',
                icon: <FontAwesomeIcon icon={faCalendarCheck} style={{ color: '#e53a9fc7' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faCalendarCheck} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_SCHEDULEAVAILABILITY,
                descriptionF: '',
                descriptionE: '',
                descriptionAbbrF: '',
                descriptionAbbrE: '',
                getThisDesc: false,
                priority: 70
            };
        case keyMenu.MENU_SURVEY:
            return {
                color: '#ff7f50',
                icon: <FontAwesomeIcon icon={faSquarePollVertical} style={{ color: '#ff7f50' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faSquarePollVertical} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_SURVEY,
                descriptionF: '',
                descriptionE: '',
                descriptionAbbrF: '',
                descriptionAbbrE: '',
                getThisDesc: false,
                priority: 80
            };
        case keyMenu.MENU_MATERIALRESOURCES:
            return {
                color: '#3086e1b5',
                icon: <FontAwesomeIcon icon={faHammer} style={{ color: '#3086e1b5' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faHammer} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_MATERIALRESOURCES,
                descriptionF: 'Matérielle',
                descriptionE: 'Material',
                descriptionAbbrF: 'Res. matérielles',
                descriptionAbbrE: 'Material res.',
                getThisDesc: true,
                priority: 90
            };
        case keyMenu.MENU_BANKBALANCE:
            return {
                color: '#bed600',
                icon: <FontAwesomeIcon icon={faScaleBalanced} style={{ color: '#bed600' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faScaleBalanced} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_BANKBALANCE,
                descriptionF: 'Solde',
                descriptionE: 'Balance',
                descriptionAbbrF: 'Solde banques',
                descriptionAbbrE: '',
                getThisDesc: false,
                priority: 100
            };
        case keyMenu.MENU_PAYROLLREGISTER:
            return {
                color: '#147781',
                icon: <FontAwesomeIcon icon={faHandHoldingDollar} style={{ color: '#147781' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faHandHoldingDollar} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_PAYROLLREGISTER,
                descriptionF: 'Registre',
                descriptionE: 'Register',
                descriptionAbbrF: 'Reg. des paies',
                descriptionAbbrE: 'Payroll reg.',
                getThisDesc: true,
                priority: 110
            };
        case keyMenu.MENU_SETTINGS:
            return {
                color: '#ff7f50',
                icon: <FontAwesomeIcon icon={faSquarePollVertical} style={{ color: '#ff7f50' }} className={stylesNav.iconRequest} />,
                iconNoColor: <FontAwesomeIcon icon={faSquarePollVertical} className={stylesNav.iconRequest} />,
                id: keyMenu.MENU_SETTINGS,
                descriptionF: '',
                descriptionE: '',
                descriptionAbbrF: '',
                descriptionAbbrE: '',
                getThisDesc: false,
                priority: 120
            };
    }
}

export function getAccessMenu(key){
    const config = JSON.parse(storage.getMenu());

    const menu = config.find(item => item.codeMenu === key);

    return menu !== undefined;
}

export function getAccessTab(key) {
    const config = JSON.parse(storage.getMenu()).filter(x => x.isTab);

    const menu = config.find(item => item.codeMenu === key);

    return menu !== undefined;
}

export function compare(a, b) {
    if (a.menuConfig.priority < b.menuConfig.priority) {
        return -1;
    }
    if (a.menuConfig.priority > b.menuConfig.priority) {
        return 1;
    }
    return 0;
}